import {EventEmitter, Input, OnInit} from '@angular/core';
import {FilterBlock} from '../filter-block';

export abstract class FilterBaseComponent implements OnInit {

  @Input() filterBlock: FilterBlock;

  @Input() refreshFilterEmitter: EventEmitter<boolean>;

  abstract isSimpleFilterAllowed(): boolean

  abstract doRefresh();

  ngOnInit(): void {
    if (this.refreshFilterEmitter){
      this.refreshFilterEmitter.subscribe(refresh => {
        if (refresh){
          this.doRefresh();
        }
      });
    }
  }

  isHide() {
    return this.filterBlock.filterConfig.hide;
  }

  preventDef(event){
    if (event) {
      event.preventDefault();
    }
  }

}
